<script setup>
import { computed, ref, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const routeComponent = ref(null);

const menuItems = [
    { to: '/profile/abonnements', label: 'plain_abonnement' },
    { to: '/profile/invoices', label: 'invoices' },
    { to: '/profile/paymentmethods', label: 'payment_methods' }
];
const isLegacyBlockActive = computed(() => window?.meta?.settings?.legacy_system_block?.active === true);
const profileMenuItems = computed(() => {
    if (isLegacyBlockActive.value) {
        return [];
    }

    return [
        { to: '/profile', label: 'profile' },
        { to: '/profile/change-password', label: 'change_password' },
        { to: '/profile/email', label: 'mail_settings' }
    ];
});

const getRoute = () => {
    switch (route.params.component) {
        case 'abonnements':
            routeComponent.value = 'Abonnements';
            break;
        case 'invoices':
            routeComponent.value = 'Invoices';
            break;
        case 'paymentmethods':
            routeComponent.value = 'Paymentmethods';
            break;
        case 'email':
            routeComponent.value = 'Email';
            break;
        case 'change-password':
            routeComponent.value = 'ChangePassword';
            break;
        case 'apitest':
            routeComponent.value = 'APITest';
            break;
        default:
            routeComponent.value = 'UserProfile';
            break;
    }
};
onMounted(() => getRoute());

watch(() => route.params.component, getRoute);
</script>

<template>
    <div class="flex flex-row">
        <div class="hidden lg:block lg:w-[250px] h-full relative shrink-0">
            <div class="fixed bg-white h-full w-[inherit] border-r border-gray-300">
                <div class="my-4">
                    <div class="p-8">
                        <small class="uppercase text-gray-400">
                            {{ $t('plain_abonnement') }}
                        </small>
                    </div>

                    <div class="flex flex-col gap-2">
                        <router-link
                            v-for="(item, index) in menuItems"
                            :key="index"
                            :to="item.to"
                            active-class="border-blue bg-blue/20"
                            class="bg-white border-l-4 pl-7 pr-3 py-2 cursor-pointer whitespace-nowrap truncate"
                        >
                            {{ $t(item.label) }}
                        </router-link>
                    </div>
                </div>
                <div v-if="profileMenuItems.length > 0" class="my-4">
                    <div class="p-4">
                        <small class="uppercase text-gray-400">
                            {{ $t('settings') }}
                        </small>
                    </div>

                    <div class="flex flex-col gap-2">
                        <router-link
                            v-for="(item, index) in profileMenuItems"
                            :key="index"
                            :to="item.to"
                            active-class="border-blue bg-blue/20"
                            class="bg-white border-l-4 pl-7 pr-3 py-2 cursor-pointer whitespace-nowrap truncate"
                        >
                            {{ $t(item.label) }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="my-8 container mx-auto w-full grow-0">
            <component :is="routeComponent" />
        </div>
    </div>
</template>
